<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Корзина</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- Cart Area Start -->
		<section class="cart py-40">
			<div class="container-fluid">
				<div class="row">
					<div class="col-xl-8">
						<div class="d-lg-block d-none">
							<table class="cart-table mb-16">
								<thead>
									<tr>
										<th>Товары</th>
										<th>Цена</th>
										<th>Количество</th>
										<th>Сумма</th>
									</tr>
								</thead>
							</table>
							<table class="cart-table" v-for="product in appModel.basketProducts" :key="product.id">
								<tbody>
									<tr class="table-row">
										<td class="pd">
											<div class="product-detail-box">
												<div class="cus-checkBox">
													<input type="checkbox" :id="'box'+product.id" :value="product.id" v-model="selectedProducts">
													<label :for="'box'+product.id" class="light-gray"></label>
												</div>
												<a href="#" class="h5 dark-black" @click.prevent="appModel.deleteProductFromBasket(product.id)">
													<i class="fal fa-times"></i>
												</a>
												<div class="img-block">
													<router-link :to="{path: '/catalog/'+product.id}">
														<img :src="product.poster" style="height: 65px;" alt="">
													</router-link>
												</div>
												<div class="d-block text-start">
													<h6>
														<router-link :to="{path: '/catalog/'+product.id}">{{product.name}}</router-link>
													</h6>
												</div>
											</div>
										</td>
										<td>
											<div class="fw-500">
												<div class="light-gray text-decoration-line-through" v-if="product.oldPrice">{{number_format(product.oldPrice)}} тг</div>
												<div>{{number_format(product.price)}} тг</div>
											</div>
										</td>
										<td>
											<div class="quantity-controller quantity-wrap">
												<input class="decrement" type="button" value="-" @click="product.count--">
												<input type="number" @wheel="$event.target.blur()" v-model.number="product.count" class="number noscroll">
												<input class="increment" type="button" value="+" @click="product.count++">
											</div>
										</td>
										<td>
											<div class="fw-500">
												<div>{{number_format(product.price * product.count)}} тг</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="table-bottom-row bg-white">
							<router-link :to="{path: '/catalog'}" class="cus-btn">Продолжить покупки</router-link>
							<form @submit.prevent="checkCoupon" class="contact-form d-flex align-items-center gap-16">
								<input type="text" class="form-control" placeholder="Код купона" name="code" id="cpCode" v-model="couponCode">
								<button type="submit" class="cus-btn">Применить</button>
							</form>
						</div>
					</div>
					<div class="col-xl-4">
						<div class="checkout-box bg-semi-white mt-xl-0 mt-48">
							<div class="checkout-title text-center mb-16">
								<h5>Итог</h5>
							</div>
							<div class="bottom-box">
								<div class="title-price mb-16">
									<h6>Сумма</h6>
									<h6 class="light-gray">{{number_format(selectedProductsPriceSum)}} тг</h6>
								</div>
								<div v-if="appModel.appliedCoupon.discount">
									<div class="hr-line mb-16"></div>
									<div class="title-price mb-16">
										<h6>Скидка по купону<br/>{{appModel.appliedCoupon.code}}</h6>
										<h6 class="light-gray">-{{number_format(appModel.appliedCoupon.discount)}} тг</h6>
									</div>
								</div>
								<div class="hr-line mb-16"></div>
								<div class="title-price mb-16">
									<h5 class="color-primary">ИТОГО</h5>
									<h5 class="color-primary">{{number_format(totalPrice)}} тг</h5>
								</div>
								<div class="hr-line mb-16"></div>
								<div class="text-end">
									<a href="#" @click.prevent="continueShopping" class="cus-btn active-btn">ПРОДОЛЖИТЬ ОФОРМЛЕНИЕ</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- Cart Area End -->

		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		selectedProducts: [],
		
		couponCode: '',
	}),
	watch: {
		'appModel.basketProducts': {
			handler(newVal) {
				newVal.forEach((product) => {
					if (product.count <= 0 || isNaN(product.count)) {
						product.count = 1;
					}
				});
				localStorage.setItem('basketProducts', JSON.stringify(this.appModel.basketProducts));
			},
			deep: true,
		},
	},
	computed: {
		selectedProductsPriceSum(){
			return this.selectedProducts.reduce((sum, productId) => {
				const product = this.appModel.basketProducts.find(p => p.id === productId);
				return sum + (product ? product.price * product.count : 0);
			}, 0);
		},
		totalPrice(){
			let discount = this.appModel.appliedCoupon.discount;
			if(this.selectedProductsPriceSum < discount){
				discount = this.selectedProductsPriceSum;
			}
			return this.selectedProductsPriceSum - discount;
		},
	},
	methods: {
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		continueShopping(){
			if(this.selectedProducts.length <= 0){
				alert('Выберите хотя бы один товар для оформления заказа');
				return false;
			}
			this.appModel.checkoutProducts = this.appModel.basketProducts.filter(product => this.selectedProducts.includes(product.id));
			this.$router.push({path: '/checkout'});
		},
		
		onInit(){
			this.selectedProducts = this.appModel.basketProducts.map(product => product.id);
		},
		checkCoupon(){
			if(this.couponCode.length <= 0){
				alert('Введите код купона');
				return false;
			}
			this.appModel.checkCoupon(this.couponCode);
			this.couponCode = '';
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.onInit();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		
		this.onInit();
		
		next();
	},
	components: {
		Benefits
	},
};
</script>